// UC Irvine's undergraduate majors (#2596, founder 2026-09-30: "majors offered
// by the college in the public page"). Read on 2026-09-30 from the official UC
// Irvine General Catalogue 2026-27: every bachelor's degree on Undergraduate
// Majors and Minors (catalogue.uci.edu/undergraduatedegrees/), grouped by the
// school its program page sits under, each checked against that school's
// catalogue page. Degrees as the catalogue writes them (B.A., B.S., B.F.A.,
// B.Mus.). Global Middle East Studies' program link is dead today; the School of
// Humanities page names it as one of its majors, so it sits there. Flags quote
// UC Irvine's dates and deadlines page (the college file's `dates` source).
// The KB's majors list was the starting point; the catalogue wins.
const majors = {
    "slug": "university-of-california-irvine",
    "read": "2026-09-30",
    "intro": "Every undergraduate major in UC Irvine's official General Catalogue, grouped by the school that offers it, with the degree it leads to. Minors and graduate programs are left out.",
    "groups": [
        {
            "name": "Charlie Dunlop School of Biological Sciences",
            "source": {
                "label": "UC Irvine General Catalogue 2026-27, Charlie Dunlop School of Biological Sciences",
                "url": "https://catalogue.uci.edu/charliedunlopschoolofbiologicalsciences/"
            },
            "majors": [
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biological Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Biology/Education",
                    "degree": "B.S."
                },
                {
                    "name": "Developmental and Cell Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Ecology and Evolutionary Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Genetics",
                    "degree": "B.S."
                },
                {
                    "name": "Human Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Microbiology and Immunology",
                    "degree": "B.S."
                },
                {
                    "name": "Neurobiology",
                    "degree": "B.S."
                },
                {
                    "name": "Physiology and Exercise Science",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Claire Trevor School of the Arts",
            "source": {
                "label": "UC Irvine General Catalogue 2026-27, Claire Trevor School of the Arts",
                "url": "https://catalogue.uci.edu/clairetrevorschoolofthearts/"
            },
            "majors": [
                {
                    "name": "Art",
                    "degree": "B.A."
                },
                {
                    "name": "Dance",
                    "degree": "B.A.",
                    "flag": "An audition or portfolio is required, between December 1 and January 31.",
                    "flagSource": "dates"
                },
                {
                    "name": "Dance",
                    "degree": "B.F.A.",
                    "flag": "An audition or portfolio is required, between December 1 and January 31.",
                    "flagSource": "dates"
                },
                {
                    "name": "Drama",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.Mus.",
                    "flag": "An audition or portfolio is required, between December 1 and January 31.",
                    "flagSource": "dates"
                },
                {
                    "name": "Music Theatre",
                    "degree": "B.F.A."
                }
            ]
        },
        {
            "name": "Donald Bren School of Information and Computer Sciences",
            "source": {
                "label": "UC Irvine General Catalogue 2026-27, Donald Bren School of Information and Computer Sciences",
                "url": "https://catalogue.uci.edu/donaldbrenschoolofinformationandcomputersciences/"
            },
            "majors": [
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Game Design and Interactive Media",
                    "degree": "B.S."
                },
                {
                    "name": "Informatics",
                    "degree": "B.S."
                },
                {
                    "name": "Information and Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Software Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "The Henry Samueli School of Engineering",
            "source": {
                "label": "UC Irvine General Catalogue 2026-27, The Henry Samueli School of Engineering",
                "url": "https://catalogue.uci.edu/thehenrysamuelischoolofengineering/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Biomedical Engineering: Premedical",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Interdisciplinary Studies",
            "source": {
                "label": "UC Irvine General Catalogue 2026-27, Interdisciplinary Studies",
                "url": "https://catalogue.uci.edu/interdisciplinarystudies/"
            },
            "majors": [
                {
                    "name": "Business Information Management",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science and Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Science and Policy",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Joe C. Wen School of Population and Public Health",
            "source": {
                "label": "UC Irvine General Catalogue 2026-27, Joe C. Wen School of Population and Public Health",
                "url": "https://catalogue.uci.edu/joecwenschoolofpopulationandpublichealth/"
            },
            "majors": [
                {
                    "name": "Public Health Policy",
                    "degree": "B.A."
                },
                {
                    "name": "Public Health Sciences",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "The Paul Merage School of Business",
            "source": {
                "label": "UC Irvine General Catalogue 2026-27, The Paul Merage School of Business",
                "url": "https://catalogue.uci.edu/thepaulmerageschoolofbusiness/"
            },
            "majors": [
                {
                    "name": "Business Administration",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "School of Education",
            "source": {
                "label": "UC Irvine General Catalogue 2026-27, School of Education",
                "url": "https://catalogue.uci.edu/schoolofeducation/"
            },
            "majors": [
                {
                    "name": "Education Sciences",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "School of Humanities",
            "source": {
                "label": "UC Irvine General Catalogue 2026-27, School of Humanities",
                "url": "https://catalogue.uci.edu/schoolofhumanities/"
            },
            "majors": [
                {
                    "name": "African American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Asian American Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Chinese Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Classics",
                    "degree": "B.A."
                },
                {
                    "name": "Comparative Literature",
                    "degree": "B.A."
                },
                {
                    "name": "East Asian Cultures",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "European Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Film and Media Studies",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "Gender and Sexuality Studies",
                    "degree": "B.A."
                },
                {
                    "name": "German Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Global Cultures",
                    "degree": "B.A."
                },
                {
                    "name": "Global Middle East Studies",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Japanese Language and Literature",
                    "degree": "B.A."
                },
                {
                    "name": "Korean Literature and Culture",
                    "degree": "B.A."
                },
                {
                    "name": "Literary Journalism",
                    "degree": "B.A."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "School of Pharmacy and Pharmaceutical Sciences",
            "source": {
                "label": "UC Irvine General Catalogue 2026-27, School of Pharmacy and Pharmaceutical Sciences",
                "url": "https://catalogue.uci.edu/schoolofpharmacyandpharmaceuticalsciences/"
            },
            "majors": [
                {
                    "name": "Pharmaceutical Sciences",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Physical Sciences",
            "source": {
                "label": "UC Irvine General Catalogue 2026-27, School of Physical Sciences",
                "url": "https://catalogue.uci.edu/schoolofphysicalsciences/"
            },
            "majors": [
                {
                    "name": "Applied and Computational Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Applied Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental and Earth System Science",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "School of Social Ecology",
            "source": {
                "label": "UC Irvine General Catalogue 2026-27, School of Social Ecology",
                "url": "https://catalogue.uci.edu/schoolofsocialecology/"
            },
            "majors": [
                {
                    "name": "Criminology, Law and Society",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Social Ecology",
                    "degree": "B.A."
                },
                {
                    "name": "Urban Studies, Planning, and Policy",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "School of Social Sciences",
            "source": {
                "label": "UC Irvine General Catalogue 2026-27, School of Social Sciences",
                "url": "https://catalogue.uci.edu/schoolofsocialsciences/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Business Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Chicano/Latino Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Cognitive Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "International Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Language Science",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S."
                },
                {
                    "name": "Quantitative Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Social Policy and Public Service",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Sue and Bill Gross School of Nursing",
            "source": {
                "label": "UC Irvine General Catalogue 2026-27, Sue and Bill Gross School of Nursing",
                "url": "https://catalogue.uci.edu/sueandbillgrossschoolofnursing/"
            },
            "majors": [
                {
                    "name": "Nursing Science",
                    "degree": "B.S."
                }
            ]
        }
    ]
};

export default majors;
